import LineOrange from "../../../common/LineOrange/LineOrange";
import styles from "../style.module.css";

export const TypesOfTransactions = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="text-center mb-5 mt-5">
            <h3>فرآیند کلی پذیرش سهام در بورس</h3>
            <LineOrange />
            <div className="d-flex justify-content-center flex-sm-row flex-md-row flex-lg-row flex-xl-row">
              <div className="col-12 col-lg-6 mb-3" >
                <div className={styles.type_box} style={{minHeight: "100%"}}>
                  <h5>پذیرش</h5>
                  <LineOrange />
                  <ul className="text-right mt-3">
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        ارائه درخواست پذیرش{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        بررسی احراز شرایط پذیرش توسط بورس{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        واریز بخش اول حق پذیرش{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        ارائه سایر مدارک و مستندات تکمیل پرونده{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        طرح در جلسه هیئت پذیرش{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-lg-6 mb-2">
                <div className={styles.type_box} style={{minHeight: "100%"}}>
                  <h5>درج نماد</h5>
                  <LineOrange />
                  <ul className="text-right mt-3">
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        ابلاغ موارد تعیین شده توسط هیئت پذیرش به متقاضی{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        واریز بخش دوم حق پذیرش{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        احراز شرایط درج{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        برگزاری جلسه کد و نماد و ابلاغ به بازار
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                        انتشار اطلاعیه درج شرکت و بارگذاری امیدنامه نهایی در
                      سایت بورس{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className={styles.type_box}>
                  <h5>عرضه اولیه عمومی</h5>
                  <LineOrange />
                  <ul className="text-right mt-3">
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      پرداخت بخش سوم حق پذیرش{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      دریافت توکن و افشای اطلاعات در سامانه کدال{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      تهیه گزارش ارزشگذاری توسط متعهد خرید{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      اقدام به سپرده گذاری سهام شرکت نزد شرکت سپرده گذاری مرکزی{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      افشای گزارش ارزشگذاری در کدال توسط ناشر{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      طرح سوال در سامانه تدان و پاسخ شرکت به سوالات{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      انتشار اطلاعیه عرضه سهام توسط شرکت بورس{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      برگذاری جلسه معارفه سهام{" "}
                    </li>
                    <li className="mb-2">
                      <img
                        src={"/asset/images/Path 80.png"}
                        className=""
                        alt=""
                      />
                      عرضه سهام به عموم{" "}
                    </li>
                  </ul>
                  {/* <p className="mt-2">
                    معاملات به صورت حراج تک قیمتی انجام می‌شود، اوراق خریداری
                    شده قابل فروش نیستند و شخص خریدار باید کالای مورد نظر را از
                    انبار تحویل بگیرد.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
